import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiBarChart2, FiDollarSign, FiGrid,
  FiHelpCircle, FiPackage, FiSettings, FiShoppingCart, FiRotateCcw, FiX,
} from 'react-icons/fi';
import { useTheme } from '../../../contexts/ThemeContext';
import '../../../assets/css/seller/components/sellersidebar/SellerSidebar.css';
import AppContext from '../../../contexts/AppContext';

const SellerSidebar = ({ isMobileOpen, onCloseMobile }) => {
  const { isDark } = useTheme();

  const menuItems = [
    { icon: <FiGrid />,         label: 'Dashboard', path: '/seller/dashboard' },
    { icon: <FiPackage />,      label: 'Products',  path: '/seller/products' },
    { icon: <FiShoppingCart />, label: 'Orders',    path: '/seller/orders' },
    { icon: <FiRotateCcw />,    label: 'Returns',   path: '/seller/returns' },
    { icon: <FiDollarSign />,   label: 'TopUp',     path: '/seller/earnings' },
    // { icon: <FiBarChart2 />,    label: 'Reporting', path: '/seller/reporting' },
    { icon: <FiHelpCircle />,   label: 'Support',   path: '/seller/support' },
    { icon: <FiSettings />,     label: 'Settings',  path: '/seller/settings' },
  ];

  return (
    <>
      {isMobileOpen && (
        <div className="seller-sidebar-overlay" onClick={onCloseMobile} />
      )}

      <aside
        className={`seller-sidebar ${isDark ? 'dark-mode' : ''}${
          isMobileOpen ? ' mobile-open' : ''
        }`}
      >
        {/* Desktop: center brand */}
        <div className="seller-brand">
          <div className="seller-brand-text">
            <h3 className="seller-brand-logo">CRAFTHIVE</h3>
            <span className="seller-brand-sub">Seller Portal</span>
          </div>
          {/* Mobile close btn inside brand for space-between */}
          <button
            className="seller-sidebar-close-btn"
            onClick={onCloseMobile}
            aria-label="Close menu"
          >
            <FiX />
          </button>
        </div>

        <nav className="seller-menu">
          {menuItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.path}
              className={({ isActive }) => `seller-menu-item ${isActive ? 'active' : ''}`}
              onClick={onCloseMobile}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default SellerSidebar;